<p-toolbar>
  <ng-template #start>
    @if (config?.enableAdd) {
    <button class="mx-2" pButton icon="pi pi-plus" label="{{ 'app.button.add' | translate }}" (click)="onAdd()"></button>
    }
    @if (config?.enableExport) {
    <button class="mx-2" pButton icon="pi pi-upload" label="{{ 'app.button.export' | translate }}" (click)="onExport()"></button>
    }
    @if (config?.enableClearFilter) {
    <button class="mx-2" pButton icon="pi pi-filter-slash" label="{{ 'app.button.clearFilters' | translate }}" (click)="clearFilters()"></button>
    }
  </ng-template>

  <ng-template #end>
    @if (config?.enableSearch) {
    <p-iconfield class="mx-2">
      <p-inputicon styleClass="pi pi-search" />
      <input pInputText type="text" placeholder="{{ 'app.button.search' | translate }}..." (input)="onSearch($event)" />
    </p-iconfield>
    }

    @if (config?.enableColumnToggle) {
    <p-multiSelect class="mx-2" [options]="columns" optionLabel="title" [(ngModel)]="selectedColumns"
      (onChange)="onColumnSelectionChange()" placeholder="{{ 'app.button.chooseColumns' | translate }}" selectedItemsLabel="{{ 'app.button.chooseColumns' | translate }}">
    </p-multiSelect>
    }
  </ng-template>
</p-toolbar>

<p-table #dt [value]="data" [paginator]="true" [rows]="request?.pageSize" [lazy]="true"
  [rowsPerPageOptions]="[10, 20, 50, 100]" [totalRecords]="config?.totalRecords || 0" [loading]="loading"
  [globalFilterFields]="config?.globalFilterFields" dataKey="id" (onPage)="onPage($event)" (onSort)="onSort($event)"
  (onFilter)="onFilter($event)">

  <!-- HEADER -->
  <ng-template pTemplate="header">
    <tr>
      @for (col of visibleColumns; track col.field) {
      <th [pSortableColumn]="col.isSortable ? col.field : undefined">
        {{ col.title }}
        @if (col.isSortable) {
        <p-sortIcon [field]="col.field"></p-sortIcon>
        }
      </th>
      }
    </tr>
  </ng-template>

  <!-- BODY -->
  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      @for (col of visibleColumns; track col.field) {
      <td>
        @switch (col.type) {
        @case ('serial') { {{ ((request.pageNumber-1) * request.pageSize) + rowIndex + 1 }} }
        @case ('date') { {{ row[col.field] | date:'shortDate' }} }
        @case ('number') { {{ row[col.field] }} }
        @case ('command_group') {
        <div class="btn-group">
          @for (cmd of col.commands; track cmd.command) {
          @if (!cmd.isConditional || cmd.condition?.(row)) {
          <button (click)="onGridCommandClick(row, cmd.command)" [title]="cmd.tooltip" class="mx-2">
            <i [ngClass]="cmd.css"></i>
          </button>
          }
          }
        </div>
        }
        @case ('custom') { {{ col.getLabel ? col.getLabel(row) : row[col.field] }} }
        @default { {{ col.getLabel ? col.getLabel(row) : row[col.field] }} }
        }
      </td>
      }
    </tr>
  </ng-template>
</p-table>
